import { IBrand } from "../../../Models/IBrand";
import { IBrandSampleSet } from "../../../Models/IBrandSampleSet";
import { IGetBrandsSampleSetDataByClosestRequest } from "../../../Models/Requests/IGetBrandsSampleSetDataByClosestRequest";
import { IGetBrandsSampleSetDataByGeoRequest } from "../../../Models/Requests/IGetBrandsSampleSetDataByGeoRequest";
import { IBaseAction } from "../Actions/BaseAction";

export interface ICorrelatedBaseAction<T> extends IBaseAction<T> {
    correlationId: number;
};

export type GetAllBrandsInitiateAction = IBaseAction<null>;
export type GetAllBrandsSuccessAction = IBaseAction<IBrand[]>;
export type GetAllBrandsFailureAction = IBaseAction<string>;
export type SetLoadingBrandsAction = IBaseAction<boolean>;
export type SetLoadingBrandSampleSetLocationsAction = IBaseAction<boolean>;
export type GetBrandSampleSetLocationsByGeoInitiateAction = ICorrelatedBaseAction<IGetBrandsSampleSetDataByGeoRequest>;
export type GetBrandSampleSetLocationsByGeoSuccessAction = ICorrelatedBaseAction<IBrandSampleSet[]>;
export type GetBrandSampleSetLocationsByGeoFailureAction = ICorrelatedBaseAction<string>;
export type GetBrandSampleSetLocationsByClosestInitiateAction = ICorrelatedBaseAction<IGetBrandsSampleSetDataByClosestRequest>;
export type GetBrandSampleSetLocationsByClosestSuccessAction = ICorrelatedBaseAction<IBrandSampleSet[]>;
export type GetBrandSampleSetLocationsByClosestFailureAction = ICorrelatedBaseAction<string>;
export type ResetBrandSampleSetAction = IBaseAction<number>;

export type BrandActionType =
    GetAllBrandsInitiateAction |
    GetAllBrandsSuccessAction |
    GetAllBrandsFailureAction |
    SetLoadingBrandsAction |
    SetLoadingBrandSampleSetLocationsAction |
    GetBrandSampleSetLocationsByGeoInitiateAction |
    GetBrandSampleSetLocationsByGeoSuccessAction |
    GetBrandSampleSetLocationsByGeoFailureAction |
    GetBrandSampleSetLocationsByClosestInitiateAction |
    GetBrandSampleSetLocationsByClosestSuccessAction |
    GetBrandSampleSetLocationsByClosestFailureAction |
    ResetBrandSampleSetAction
;

/** brands */
export const GET_ALL_BRANDS_INITIATE = "GET_ALL_BRANDS_INITIATE";
export const GET_ALL_BRANDS_SUCCESS = "GET_ALL_BRANDS_SUCCESS";
export const GET_ALL_BRANDS_FAILURE = "GET_ALL_BRANDS_FAILURE";
export const SET_LOADING_BRANDS = "SET_LOADING_BRANDS";

/** sample set */
export const SET_LOADING_BRAND_SAMPLE_SET_LOCATIONS = "SET_LOADING_BRAND_SAMPLE_SET_LOCATIONS";

/** sample set by geo */
export const GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_INITIATE = "GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_INITIATE";
export const GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_SUCCESS = "GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_SUCCESS";
export const GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_FAILURE = "GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_FAILURE";

/** sample set by geo */
export const GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_INITIATE = "GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_INITIATE";
export const GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_SUCCESS = "GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_SUCCESS";
export const GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_FAILURE = "GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_FAILURE";

/** reset */
export const RESET_BRAND_SAMPLE_SET = "RESET_BRAND_SAMPLE_SET";
